/*
  schema_sha256: fbf1748b80dc6ff3d2207d7fee6343dd6aee5d8e66ba4e0ab0761531646e2d23
  zoolander_commit: 5b659f93c781f62eca38d54f2d5a2edd81d1a49f

  DO NOT MANAULLY MODIFY THIS FILE
  This file is auto generated by: frontend/data-v2/generate_schema.sh
*/ const CURRENT_PINNED_VERSION = '2025-04-25-18.internal';
export default CURRENT_PINNED_VERSION;
export const VERIFICATION_MODE = false;

//# sourceMappingURL=version.js.map